import { useEffect } from 'react';
import { isProduction } from 'utils/env/isProduction';

export const BattlesV2 = () => {
	useEffect(() => {
		window.location.replace(isProduction ? '/panel/my-battles' : `${process.env.REACT_APP_PANEL_HOST}/my-battles`);
	}, []);

	return null;
};
export default BattlesV2;
